import React from 'react';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { priority } from 'Constants/Database';
import useTranslation from 'Hooks/useTranslation';
import { buttonStyle, buttonStyle2 } from '../style';

export default function SelectButton({
  priorityType = priority.Normativa,
  isUpload = false,
  onClick = () => {},
  acceptedFiles = [],
  isLoading = false,
}) {
  const { t2 } = useTranslation('EmployeeAssess');
  if (priorityType === priority.Normativa) {
    return (
      <Button variant="contained" style={buttonStyle(false)} onClick={onClick}>
        {t2('Accept')}
      </Button>
    );
  }
  if (priorityType === priority.Institucional) {
    return (
      <Button variant="contained" style={buttonStyle(false)} onClick={onClick}>
        {t2('Approve')}
      </Button>
    );
  }
  return (
    <LoadingButton
      loading={isLoading}
      disabled={!isUpload}
      variant="contained"
      style={buttonStyle2(isUpload)}
      onClick={() => onClick(acceptedFiles)}
    >
      {t2('Approve')}
    </LoadingButton>
  );
}
